import { render, staticRenderFns } from "./remoteManagement.vue?vue&type=template&id=05296a74&scoped=true"
import script from "./remoteManagement.vue?vue&type=script&lang=js"
export * from "./remoteManagement.vue?vue&type=script&lang=js"
import style0 from "./remoteManagement.vue?vue&type=style&index=0&id=05296a74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05296a74",
  null
  
)

export default component.exports